<template>
    <div class="muven-container">
        <div class="muven-router-name-container">
            <p class="muven-router-name">Marcas</p>
        </div>

        <div class="muven-content">
            <Loading page v-if="loading" />        

            <ConfirmationExclusionModalCmp 
                ref="confirmationExclusionModal"
                @confirm="confirmExclusionHandler" />

            <AuditListQuickVisualizationCmp 
                ref="auditListQuickVisualizationModal" />

            <div class="mb-3" v-if="!loading">
                <div>
                    <button type="button" 
                        class="btn btn-primary mr-3"
                        @click="showFilterModal()">
                        Filtro
                    </button>

                    <button type="button" 
                        class="btn btn-outline-secondary"
                        @click="gotoBrandForm()">
                        Nova marca
                    </button>
                </div>
            </div>

            <FilterInformationCmp 
                v-if="!loading"
                :filter-submitted="brandFilterSubmitted"
                :filter-properties="brandFilterProperties" />

            <div class="modal" tabindex="-1" role="dialog" id="muven-brand-list-filter-modal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Filtro de marcas</h5>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12 form-group">
                                    <label>Tipo de filtro</label>
                                    <div class="btn-group">
                                       <button v-for="(filterOption, indexFilterOption) in filterOptions" :key="indexFilterOption"
                                        type="button" 
                                        class="btn btn-outline-secondary"
                                        :class="{active: filterOption.active}"
                                        @click="updateFilterOption(filterOption)">{{filterOption.description}}</button>
                                    </div>
                                </div>
                            </div>

                            <div class="row" v-if="isFilterOptionByChannelInfo">
                                <div class="col-12 form-group">
                                    <label>Id no canal</label>
                                    <input type="text" 
                                        class="form-control" 
                                        v-model="brandFilter.idExternalChannel" />
                                </div>
                            </div>

                            <div class="row" v-if="isFilterOptionByBackendInfo">
                                <div class="col-12 form-group">
                                    <label>Id na retaguarda</label>
                                    <input type="text" 
                                        class="form-control" 
                                        v-model="brandFilter.idSource" />
                                </div>
                            </div>

                            <div class="row" v-if="isFilterOptionAdvanced">
                                <div class="col-12 form-group">
                                    <label>Nome</label>
                                    <input type="text" 
                                        class="form-control" 
                                        v-model="brandFilter.name" />
                                </div>

                                <div class="col-12 form-group">
                                    <label>Título</label>
                                    <input type="text" 
                                        class="form-control" 
                                        v-model="brandFilter.title" />
                                </div>

                                <div class="col-12 form-group">
                                    <label>Palavras-chave</label>
                                    <input type="text" 
                                        class="form-control" 
                                        v-model="brandFilter.keywords" />
                                </div>

                                <div class="col-12 form-group">
                                    <label>Exportação</label>
                                        <multiselect
                                            v-model="brandFilter.allowExport"
                                            :options="exportableList"
                                            :multiple="false"
                                            :show-labels="false"
                                            label="description"
                                            track-by="bool"
                                            placeholder="" />
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" 
                                class="btn btn-primary" 
                                @click="getBrandsWithFilter(brandFilter)"
                                :disabled="loadingFilter">
                                    Filtrar
                                    <Loading v-show="loadingFilter" />
                            </button>

                            <button type="button" 
                                class="btn btn-outline-secondary" 
                                @click="clearFilter()">Restaurar</button>

                            <button type="button" 
                                class="btn btn-outline-secondary" 
                                @click="closeFilterModal()">Fechar</button>
                        </div>
                    </div>
                </div>
            </div>

            <NothingFound v-if="nothingToShow" />

            <div v-if="!loading && !nothingToShow">
                <div class="table-responsive">
                    <table class="table table-sm table-hover table-striped">
                        <thead>
                            <tr>
                                <th>Nome</th>
                                <th>Palavras chave</th>
                                <th class="status-col">Status</th>
                                <th></th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(brand, index) in brandList" :key="index">
                                <td>{{brand.name | infoOrPlaceholder}}</td>
                                <td>{{brand.keywords | infoOrPlaceholder}}</td>
                                <td>
                                    <span v-if="brand.isActive">
                                        <span class="muven-td-icon" >
                                            <fa icon="check-circle" 
                                                class="text-success" />
                                        </span>
                                    
                                        <span>Ativa</span>
                                    </span>

                                    <span v-if="!brand.isActive">
                                        <span class="muven-td-icon">
                                            <fa icon="ban"                                             
                                                class="text-muted" />
                                        </span>

                                        <span>Inativa</span>
                                    </span>
                                </td>
                                <td class="text-center muven-td-with-buttons">
                                    <button type="button" 
                                        class="btn btn-default text-muted" 
                                        data-toggle="dropdown" >
                                        <fa icon="ellipsis-v" v-show="!brand.loadingListAction" />
                                        <fa icon="sync-alt" spin v-show="brand.loadingListAction" />
                                    </button>

                                    <div class="dropdown-menu dropdown-menu-right muven-action-menu">
                                        <router-link class="dropdown-item"
                                            :to="detailUrl(brand)">
                                            <fa icon="file-alt" fixed-width class="muven-action-icon" />
                                            <span class="muven-action-label">Detalhes</span>
                                        </router-link>

                                        <span class="dropdown-item"
                                            @click="gotoBrandForm(brand)">
                                            <fa icon="edit" fixed-width class="muven-action-icon" />
                                            <span class="muven-action-label">Editar</span>
                                        </span>

                                        <a class="dropdown-item"
                                            :href="getProductListFilterWithBrandPath(brand)"
                                            target="_blank"
                                            rel="noopener"
                                            title="Abre em uma nova aba">
                                            <fa icon="box" fixed-width class="muven-action-icon" />
                                            <span class="muven-action-label">Visualizar produtos vinculados</span>
                                            <fa icon="external-link-alt" class="muven-action-external" />
                                        </a>

                                        <p class="dropdown-divider"></p>

                                        <span class="dropdown-item"
                                            @click="forceChannelsSync(brand)">
                                            <fa icon="sync-alt" fixed-width class="muven-action-icon" />
                                            <span class="muven-action-label">Forçar sincronização</span>
                                        </span>

                                        <p class="dropdown-divider"></p>

                                        <span class="dropdown-item muven-action-danger"
                                            @click="openConfirmationExclusionModal(brand)">
                                            <fa icon="trash-alt" fixed-width class="muven-action-icon" />
                                            <span class="muven-action-label">Excluir marca</span>
                                        </span>

                                        <p class="dropdown-divider"></p>

                                        <span class="dropdown-item"
                                            @click="showAuditQuickVisualization(brand)">
                                            <fa icon="search" fixed-width class="muven-action-icon" />
                                            <span class="muven-action-label">Auditoria rápida</span>
                                        </span>

                                        <a class="dropdown-item"
                                            :href="getAuditUrl(brand.id, EntityEnum.Brand)"
                                            target="_blank"
                                            rel="noopener"
                                            title="Abre em uma nova aba">
                                            <fa icon="history" fixed-width class="muven-action-icon" />
                                            <span class="muven-action-label">Ir para auditoria</span>
                                            <fa icon="external-link-alt" class="muven-action-external" />
                                        </a>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <ListCount :amount="brandList.length" />
                </div>

                <div v-if="showPaginationButton" class="text-center">
                    <button class="btn btn-outline-secondary"
                        @click="getMoreBrands()"
                        :disabled="loadingNextPage">
                        <span v-show="!loadingNextPage">Mais resultados</span>
                        <fa v-show="loadingNextPage" icon="sync-alt" spin/>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {cloneDeep} from 'lodash'
import brandService from '@/brand/services/BrandService'
import { BrandListFilterModel } from '@/brand/models/BrandListFilterModel'
import { PaginationModel } from '@/utils/models/PaginationModel'
import modalService from '@/utils/services/ModalService'
import { dateTimeFilter } from '@/utils/filters/DateTimeFilter'
import FilterInformationCmp from '@/utils/components/FilterInformationCmp'
import { EntityEnum } from '@c2b/muven-commons'
import GetAuditUrl from '@/utils/mixins/GetAuditUrl'
import { infoOrPlaceholder } from '@/utils/filters/InformationOrPlaceholderFilter'
import ConfirmationExclusionModalCmp from '@/utils/components/ConfirmationExclusionModalCmp'
import AuditListQuickVisualizationCmp from '@/audit/components/AuditListQuickVisualizationCmp'

const ID_FILTER_MODAL = '#muven-brand-list-filter-modal'
const FILTER_BY_BACKEND_INFO = 'filter_by_backend_info'
const FILTER_BY_CHANNEL_INFO = 'filter_by_channel_info'
const FILTER_ADVANCED = 'filter_advanced'

export default {
    name: 'BrandListView',
    data() {
        return {
            EntityEnum,
            loading: true,
            loadingFilter: false,
            loadingNextPage: false,
            showPaginationButton: true,
            pagination: new PaginationModel(),
            brandFilter: new BrandListFilterModel(),
            brandFilterSubmitted: new BrandListFilterModel(),
            brandList: [],
            filterOptions: [
                {
                    enum: FILTER_ADVANCED,
                    description: 'Geral',
                    active: true,
                },
                {
                    enum: FILTER_BY_BACKEND_INFO,
                    description: 'Retaguarda',
                    active: false,
                },
                {
                    enum: FILTER_BY_CHANNEL_INFO,
                    description: 'Canal',
                    active: false,
                },
            ],
            filterOptionSelected: {
                enum: FILTER_ADVANCED,
                description: 'Geral',
                active: true,
            },
            exportableList: [
                {
                    bool: true,
                    description: 'Apenas marcas que SÃO EXPORTADAS'
                },
                {
                    bool: false,
                    description: 'Apenas marcas que NÃO SÃO EXPORTADAS'
                },
            ],
            brandFilterProperties: [
                {
                    type: 'string',
                    label: 'Nome',
                    property: 'name',
                },
                {
                    type: 'string',
                    label: 'Título',
                    property: 'title',
                },
                {
                    type: 'string',
                    label: 'Palavras-chave',
                    property: 'keywords',
                },
                {
                    type: 'string',
                    label: 'Id na retaguarda',
                    property: 'idSource',
                },
                {
                    type: 'string',
                    label: 'Id no canal',
                    property: 'idExternalChannel',
                },
                {
                    type: 'booleanwrapped',
                    label: 'Exportação',
                    property: 'allowExport',
                },
            ],
        }
    },
    mixins: [
        GetAuditUrl,
    ],
    components: {
        FilterInformationCmp,
        ConfirmationExclusionModalCmp,
        AuditListQuickVisualizationCmp,
    },
    filters: {
        dateTimeFilter,
        infoOrPlaceholder,
    },
    methods: {
        async getMoreBrands() {
            try {
                this.loadingNextPage = true
                const newBrandList = await brandService.getBrands(this.pagination.actual(), this.brandFilter)
                this.brandList.push(...newBrandList)

                if (!newBrandList.length) {
                    this.showPaginationButton = false
                }

                this.pagination.next()
            } catch(e) {
                this.$floatingAlert.error({
                    message: e.message,
                })
            }

            this.loadingNextPage = false
        },
        async getBrandsWithFilter(filterList) {
            this.showPaginationButton = true
            this.brandFilterSubmitted = cloneDeep(filterList)
            this.pagination.reset()
            this.loadingFilter = true
            try {
                this.brandList = await brandService.getBrands(this.pagination.actual(), filterList)
                this.closeFilterModal()
                this.pagination.next()
            } catch (e) {
                this.$floatingAlert.error({
                    message: e.message,
                })
            }

            this.loadingFilter = false
        },
        updateFilterOption(filterOption) {
            this.filterOptions.forEach((fo) => {
                fo.active = false
            })

            this.filterOptionSelected = Object.assign(filterOption, {active: true})            
            this.clearFilter()
        },
        goto(brand) {
            this.$router.push(`marcas/${brand.id}`)
        },
        getProductListFilterWithBrandPath(brand) {
            return `/produtos?withBrand=${brand.id}`
        },
        gotoBrandForm(brand) {
            if (!!brand) {
                this.$router.push(`marcas/${brand.id}/edicao`)
                return
            }

            this.$router.push(`marcas/nova`)
        },
        async showFilterModal() {
            await modalService.show(ID_FILTER_MODAL)
        },
        async closeFilterModal() {
            await modalService.hide(ID_FILTER_MODAL)
        },
        clearFilter() {
            this.brandFilter = new BrandListFilterModel()
        },
        openConfirmationExclusionModal(brand) {
            const info = {
                id: brand.id,
                title: 'Exclusão de marca',
                message: `Tem certeza que deseja excluir a marca <span style="font-weight: 600; color: var(--text-soft); text-transform: uppercase; letter-spacing: 1px;">${brand.name}</span>?`,
            }

            this.$refs.confirmationExclusionModal.open(info)
        },
        async confirmExclusionHandler({id}) {
            try {
                await brandService.deleteBrand(id)

                for (let i = 0; i < this.brandList.length; i++) {
                    if (this.brandList[i].id === id) {
                        this.$floatingAlert.success({
                            message: `Marca <span style="font-weight: 600; color: var(--text-soft); text-transform: uppercase; letter-spacing: 1px;">${this.brandList[i].name}</span> excluída com sucesso.`,
                        })
                        this.brandList.splice(i, 1)
                        break
                    }
                }
            } catch (e) {
                this.$floatingAlert.error({
                    message: e.message,
                })
            }

            this.$refs.confirmationExclusionModal.close()
        },
        async forceChannelsSync(brand) {
            brand.loadingListAction = true

            try {
                await brandService.forceChannelsSync(brand.id)
                this.$floatingAlert.info({
                    message: `Solicitação de sincronização da marca <b>${brand.name}</b> registrado com sucesso.`,
                    timeVisible: 10000,
                })
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message || `Houve um problema no momento de forçar a sincronização da marca <b>${brand.name}</b>. Tente novamente mais tarde.`  
                })
            }

            brand.loadingListAction = false
        },
        async showAuditQuickVisualization(brand) {
            brand.loadingListAction = true

            await this.$refs.auditListQuickVisualizationModal.showModal({
                idEntity: brand.id,
                entityList: EntityEnum.Brand,
                getDescription: () => `Marca: ${brand.name}`,
            });

            brand.loadingListAction = false
        },
    },
    async mounted() {
        try {
            this.brandList = await brandService.getBrands(this.pagination.actual(), this.brandFilter)
            this.pagination.next()
        } catch (err) {
            this.$floatingAlert.error({
                message: err.message,
            })
        }

        this.loading = false
    },
    computed: {
        nothingToShow() {
            return !this.loading && !this.brandList.length
        },     
        isFilterOptionByBackendInfo() {
            return this.filterOptionSelected.enum === FILTER_BY_BACKEND_INFO
        },
        isFilterOptionByChannelInfo() {
            return this.filterOptionSelected.enum === FILTER_BY_CHANNEL_INFO
        },
        isFilterOptionAdvanced() {
            return this.filterOptionSelected.enum === FILTER_ADVANCED
        },
        detailUrl() {
            return (brand) => {
                return `/marcas/${brand.id}`
            }
        },
    },
}
</script>

<style lang="scss" scoped>

</style>
